import { useEffect, useState } from 'react';
import stringUtils from '../utils/string';

function useCollapseText(text, collapsedLength) {
	// eslint-disable-next-line
	const hasCollapseMode =
		!stringUtils.isNullOrEmpty(text) && Number.isInteger(collapsedLength) ? text.length > collapsedLength : false;
	const [isCollapsed, setIsCollapsed] = useState(true);
	const [collapseText, setCollapseText] = useState('');

	useEffect(() => {
		if (!stringUtils.isNullOrEmpty(text)) {
			setCollapseText(text);
		}
	}, [text]);

	useEffect(() => {
		if (hasCollapseMode) {
			const collapsedText = text.slice(0, collapsedLength);

			if (isCollapsed) {
				setCollapseText(`${collapsedText}...`);
			} else {
				setCollapseText(text);
			}
		}
	}, [hasCollapseMode, isCollapsed, text, collapsedLength]);

	return {
		collapseText,
		hasCollapseMode,
		isCollapsed,
		setIsCollapsed,
	};
}

export default useCollapseText;
